import { render, staticRenderFns } from "./dragDiv.vue?vue&type=template&id=6fe82c40&"
import script from "./dragDiv.vue?vue&type=script&lang=js&"
export * from "./dragDiv.vue?vue&type=script&lang=js&"
import style0 from "./dragDiv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports